module.exports = __webpack_public_path__ + "static/media/flower_base_layer.aeb3da00.png";